import { render, staticRenderFns } from "./TenantsWidget.vue?vue&type=template&id=bdef2fb6&scoped=true&"
import script from "./TenantsWidget.vue?vue&type=script&lang=js&"
export * from "./TenantsWidget.vue?vue&type=script&lang=js&"
import style0 from "./TenantsWidget.vue?vue&type=style&index=0&id=bdef2fb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdef2fb6",
  null
  
)

export default component.exports